import React from "react";
import { Card, makeColumnContentForCard } from "collections/Cards";
import { useTranslation } from "utilities/i18n";
import { MemberDetailsProps } from "./MemberDetails";
import { ConnectionStatusIcon } from "elements";

export const MemberDetailsCard: React.FC<MemberDetailsProps & {
  title?: string;
}> = ({
  user_id,
  name,
  blocked,
  email,
  last_ip,
  last_login,
  created_at,
  logins_count,
  title
}) => {
  const { t } = useTranslation();
  const cardFields = [
    {
      key: "user_name",
      label: t("NAME"),
      content: <p>{name}</p>
    },
    {
      key: "status",
      label: t("STATUS"),
      content: (
        <p className="status">
          <ConnectionStatusIcon connected={!blocked} />
          {blocked ? t("DISABLED") : t("ENABLED")}
        </p>
      )
    },
    {
      key: "email",
      label: t("EMAIL"),
      content: <p>{email}</p>
    },
    {
      key: "public_ip",
      label: t("PUBLIC_IP_ADDRESS"),
      content: <p>{last_ip}</p>
    },
    {
      key: "last_sign_in",
      label: t("LAST_SIGN_IN"),
      content: (
        <p>
          {last_login
            ? new Date(Date.parse(last_login)).toLocaleDateString()
            : ""}
        </p>
      )
    },
    {
      key: "first_sign_in",
      label: t("FIRST_SIGN_IN"),
      content: (
        <p>
          {created_at
            ? new Date(Date.parse(created_at)).toLocaleDateString()
            : ""}
        </p>
      )
    },
    {
      key: "sessions",
      label: t("NO_OF_SESSIONS"),
      content: <p>{logins_count}</p>
    }
  ];

  return (
    <div data-testid="member-detail-card">
      {title && <h4 className="page-title">{title}</h4>}
      <h6 className="section-title mb-1">{t("INFORMATION")}</h6>
      <Card key={user_id} className="table-card">
        {makeColumnContentForCard(cardFields, 4)}
      </Card>
    </div>
  );
};

export default MemberDetailsCard;
